import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import { AddWidgetButtonType } from 'src/models/employerConstructor/widget.types';

const employerConstructorAutoAddWidget = autoGeneratedReducer<AddWidgetButtonType>(null);
export { employerConstructorAutoAddWidget };
